import React, { useState } from "react";
import AlertTriangleIcon from "shared/components/icons/AlertTriangleIcon";
import ChevronDownIcon from "shared/components/icons/chevron/ChevronDownIcon";
import ChevronUpIcon from "shared/components/icons/chevron/ChevronUpIcon";
import PillarFormLoadingButton from "shared/components/pillar-form/components/PillarFormLoadingButton";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

/**
 * The row a table shows when its `dataQuery` failed.
 *
 * The message is whatever `handleError` decided this caller may see, so it is
 * safe to print as-is: a member gets the public half, an admin or a non-prod
 * caller also gets the privileged detail and the server stack.
 */
const PillarTableError = () => {
  const { columns, dataQueryError, refetchData, testidTable } =
    usePillarTableContext();
  const [stackExpanded, setStackExpanded] = useState(false);

  if (!dataQueryError) {
    return <></>;
  }

  return (
    <tr
      className="pillartable-table-row-general bg-neutral-light"
      data-testid={testidTable ? `${testidTable}-error` : undefined}
    >
      <td colSpan={columns.length + 1}>
        <div className="flex flex-col justify-center items-center gap-y-0.5 py-1">
          <div className="flex justify-center items-center gap-x-0.5 text-status-danger-tint">
            <AlertTriangleIcon className="shrink-0" />
            <span
              data-testid={
                testidTable ? `${testidTable}-error-message` : undefined
              }
            >
              {dataQueryError.message}
            </span>
          </div>
          {dataQueryError.serverStack && (
            <div className="max-w-full">
              <button
                type="button"
                className="flex justify-center items-center gap-x-0.5 mx-auto cursor-pointer text-sm"
                aria-expanded={stackExpanded}
                data-testid={
                  testidTable ? `${testidTable}-error-details` : undefined
                }
                onClick={() => setStackExpanded((expanded) => !expanded)}
              >
                {stackExpanded ? (
                  <ChevronUpIcon className="h-2 w-2" />
                ) : (
                  <ChevronDownIcon className="h-2 w-2" />
                )}
                Details
              </button>
              <pre
                className={`max-h-4xl overflow-auto whitespace-pre-wrap break-words text-left text-sm ${
                  stackExpanded ? "" : "hidden"
                }`}
              >
                {dataQueryError.serverStack}
              </pre>
            </div>
          )}
          {refetchData && (
            <PillarFormLoadingButton
              label="Try Again"
              className="button-regular-neutral-filled"
              testid={testidTable ? `${testidTable}-error-retry` : undefined}
              onClick={async () => {
                await refetchData();
              }}
            />
          )}
        </div>
      </td>
    </tr>
  );
};

export default PillarTableError;
